import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { BookingReasons } from '@raskrask-dk/raskrask-utils'

export type CodeType = 'GiftCard' | 'KlippeCard' | 'PromoCode' | ''
const codes: CodeType[] = ['GiftCard', 'KlippeCard', 'PromoCode']

const landCodes = [
    { label: '+45', value: '45', countryCode: 'DK' },
    { label: '+46', value: '46', countryCode: 'SE' },
    { label: '+47', value: '47', countryCode: 'NO' },
]

const initialState = {
    codes: codes,
    bookingReasons: [] as BookingReasons,
    landCodes: landCodes,
    priceToPay: 0,
    showHelp: true,
}

export const detailsSettingsSlice = createSlice({
    name: 'detailsSettings',
    initialState,
    reducers: {
        setCodes: (state, action: PayloadAction<typeof codes>) => {
            state.codes = action.payload
        },
        setBookingReasons: (state, action: PayloadAction<BookingReasons>) => {
            state.bookingReasons = action.payload
        },
        setLandCodes: (state, action: PayloadAction<LabelLandCode[]>) => {
            state.landCodes = action.payload
        },
        setPriceToPay: (state, action: PayloadAction<number>) => {
            state.priceToPay = action.payload
        },
        setShowHelp: (state, action: PayloadAction<boolean>) => {
            state.showHelp = action.payload
        },
    },
})

export const {
    setCodes,
    setBookingReasons,
    setLandCodes,
    setPriceToPay,
    setShowHelp,
} = detailsSettingsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getCodes = (state: RootState): CodeType[] =>
    state.detailsSettings.codes
export const getBookingReasons = (state: RootState): BookingReasons =>
    state.detailsSettings.bookingReasons
export const getLandCodes = (state: RootState): LabelLandCode[] =>
    state.detailsSettings.landCodes
export const getPriceToPay = (state: RootState): number =>
    state.detailsSettings.priceToPay
export const getShowHelp = (state: RootState): boolean =>
    state.detailsSettings.showHelp

export default detailsSettingsSlice.reducer
